export const getRequestedStripeMode = () => (
  String(process.env.REACT_APP_STRIPE_MODE || '').toLowerCase() === 'live' ? 'live' : 'test'
);

export const withRequestedStripeMode = (body) => ({
  ...body,
  stripe_mode: getRequestedStripeMode(),
});
